/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT MANUALLY. RUN `pnpm generate-types` TO REGENERATE.
 * Generated on 2026-04-30T09:50:33.955Z
 */

export type Region =
  | 'verticals-services'
  | 'real-estate'
  | 'motors'
  | 'ciam'
  | 'property24'
  | 'autotrader'
  | 'marketpay'
  | 'cee'
  | 'moderation-hermes'
  | 'console'
  | 'olxba'
  | 'moderation-neo'
  | 'frejaml';

export type Tracker =
  | 'appsflyer'
  | 'tune'
  | 'mixpanel'
  | 'gtag'
  | 'adjust'
  | 'gtm'
  | 'hydra'
  | 'facebook'
  | 'ga'
  | 'braze'
  | 'clevertap'
  | 'surveys'
  | 'laquesis';

export type TrackerAbbreviation = 'A' | 'T' | 'M' | 'GTAG' | 'ADJUST' | 'G' | 'H' | 'F' | 'GA' | 'BRAZE' | 'CT' | 'LQS' | 'LQ';

export const AVAILABLE_TRACKERS: Record<Tracker, TrackerAbbreviation> = {
  appsflyer: 'A',
  tune: 'T',
  mixpanel: 'M',
  gtag: 'GTAG',
  adjust: 'ADJUST',
  gtm: 'G',
  hydra: 'H',
  facebook: 'F',
  ga: 'GA',
  braze: 'BRAZE',
  clevertap: 'CT',
  surveys: 'LQS',
  laquesis: 'LQ',
} as const;
